import { createAsyncActionType } from './index';

export const ACADEMY_LIST_GET = createAsyncActionType('academy', 'ACADEMY_LIST_GET');
export const ACADEMY_DETAILS_GET = createAsyncActionType('academy', 'ACADEMY_DETAILS_GET');
export const ACADEMY_SET_FAVOURITE = createAsyncActionType('academy', 'ACADEMY_SET_FAVOURITE');
export const ACADEMY_LO_SET_LIKEDISLIKE = createAsyncActionType('academy', 'ACADEMY_LO_SET_LIKEDISLIKE');
export const ACADEMY_COURSE_DETAILS_SET_VIEWS = createAsyncActionType('academy', 'ACADEMY_COURSE_DETAILS_SET_VIEWS');
export const ACADEMY_LO_SET_VIEWS = createAsyncActionType('academy', 'ACADEMY_LO_SET_VIEWS');
export const ACADEMY_LO_SET_COMMENT = createAsyncActionType('academy', 'ACADEMY_LO_SET_COMMENT');
export const ACADEMY_CATEGORIES_GET = createAsyncActionType('academy', 'ACADEMY_CATEGORIES_GET');
export const ACADEMY_LO_UNSET = createAsyncActionType('academy', 'ACADEMY_LO_UNSET');
